<template>
    <v-container fluid fill-height class="pa-0"
                 :style="backgroundImage">
        <p-loader></p-loader>
        <p-snackbar></p-snackbar>
        <div class="background-mask">
            <v-layout align-center justify-center fill-height>
                 <!-- <vue-particles
                    v-if="particles_reload"
                    color="#dedede"
                    :particleOpacity="0.7"
                    :particlesNumber="20"
                    shapeType="circle"
                    :particleSize="4"
                    linesColor="#dedede"
                    :linesWidth="1"
                    :lineLinked="true"
                    :lineOpacity="0.4"
                    :linesDistance="150"
                    :moveSpeed="3"
                    :hoverEffect="true"
                    hoverMode="grab"
                    :clickEffect="true"
                    clickMode="push"
                >
                </vue-particles> -->
                <router-view/>
            </v-layout>
        </div>
    </v-container>
</template>

<script>
  /* eslint-disable */
//   import Vue from 'vue'
//   import VueParticles from 'vue-particles'
  import PLoader from './../shared/PLoader'
  import PSnackbar from './../shared/PSnackbar'
//   Vue.use(VueParticles)

  export default {
    name: 'out',
    components: {PSnackbar, PLoader},
    data: function () {
      return {
        backgroundImage: ''
      }
    },
    mounted: function () {
      this.backgroundImage = {
        background: `url(https://mdbootstrap.com/img/Photos/Horizontal/Nature/full%20page/img%20%28${1 + Math.floor(Math.random() * 10)}%29.jpg) no-repeat center center`,
        backgroundSize: 'cover'
      }
    }
  }
</script>

<style>
  /* Quebra de linha em palavra */
  .break-word {
    word-break: break-word;
  }
  /* Quebra de linha em caracter */
  .break-all {
    word-break: break-all;
  }
  /* As frases terão apenas uma linha */
  .one-line {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  /* As frases terão apenas 2 linha */
  .two-line {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  
  .background-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    top: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/Out.vue